<template>
  <ui-menu-base-trigger @focus="handleFocus">
    <template #default="{ openMenu }">
      <button
        ref="buttonRef"
        v-tippy="{ content }"
        type="button"
        data-testid="quick-nav"
        :class="[
          'focus:bg-gray-20 hover:bg-gray-20 text-gray-90 group flex cursor-pointer items-center gap-2 rounded px-2 py-1 font-medium duration-200 ease-out',
          active && 'bg-gray-20',
        ]"
        @click="openMenu"
        @keydown.enter="openMenu"
      >
        <span
          ref="titleRef"
          :key="content"
          v-tippy="{
            content: isOverflowing ? content : null,
            delay,
          }"
          class="truncate"
          >{{ content || loadingText }}</span
        >
        <ui-badge v-if="$slots.badge" :class="['group-hover:bg-white', active && 'bg-white']">
          <slot name="badge" />
        </ui-badge>
      </button>
    </template>
  </ui-menu-base-trigger>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import useOverflowCheck from '@klausapp/shared/composables/useOverflowCheck'

import UiBadge from '../../UiBadge.vue'
import UiMenuBaseTrigger from './UiMenuBaseTrigger.vue'

defineProps<{
  active?: boolean
  content?: string
  loadingText?: string
}>()

const delay = [400, 0]
const titleRef = ref<HTMLElement>()

const { isOverflowing } = useOverflowCheck(titleRef)

const buttonRef = ref<HTMLButtonElement | null>(null)

const handleFocus = () => {
  buttonRef.value?.focus()
}
</script>
